import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, FormattedMessage } from 'react-intl';

import Checkbox from '@bibliocommons/base-checkbox';

import SimpleField from '../SimpleField';

import './StatusField.scss';

const VISIBLE_FILTERS_LIMIT = 15;

const onlineOnlyFilter = filters => filters.find(f => f.get('value') === '_online_');

function renderFilters(filters, renderFilter) {
  return (
    <>
      {renderFilter(onlineOnlyFilter(filters), 0)}
      <p className="subcategory-title">
        <FormattedMessage id="Locations.locationsHeading" />
      </p>
      <ul className="filter-list">
        {filters
          .filter((f, index) => {
            return (index < VISIBLE_FILTERS_LIMIT || f.get('applied')) && f.get('label') !== '_online_';
          })
          .valueSeq()
          .map(renderFilter)}
      </ul>
    </>
  );
}

export function StatusField({
  filters,
  singleBranch,
  fieldId,
  intl,
  hasMore,
  handleExpandField,
  activeFilters,
  initialIsExpanded,
  handleCloseExpandField,
  handleToggleExpandedField,
  handleToggleFilter,
  isConjunctive
}) {
  function renderSingleBranchStatusField() {
    const availableNow = filters.find(f => f.get('value') === '_anywhere_');
    const physicalCopy = filters.find(f => f.get('value') === '_physical_');
    const onlineOnly = onlineOnlyFilter(filters);
    const classNames = applied => cn('filter filter--single-branch', { applied });

    return (
      <div className="cp-status-field">
        {availableNow && !physicalCopy && (
          <div key={`${fieldId}-${availableNow.get('value')}`} className={classNames(availableNow.get('applied'))}>
            <Checkbox
              checked={availableNow.get('applied')}
              dataKey="checkbox-filter"
              handleChange={() => handleToggleFilter(fieldId, availableNow)}
              id={`field-${availableNow.get('value')}`}
              label={intl.formatMessage({ id: 'STATUS._anywhere_.singleBranch' })}
            />
          </div>
        )}
        {physicalCopy ? (
          <div key={`${fieldId}-${physicalCopy.get('value')}`} className={classNames(physicalCopy.get('applied'))}>
            <Checkbox
              checked={physicalCopy.get('applied')}
              dataKey="checkbox-filter"
              handleChange={() => handleToggleFilter(fieldId, physicalCopy)}
              id={`field-${physicalCopy.get('value')}`}
              label={intl.formatMessage({ id: 'STATUS._physical_.singleBranch' })}
            />
          </div>
        ) : null}
        {onlineOnly ? (
          <div key={`${fieldId}-${onlineOnly.get('value')}`} className={classNames(onlineOnly.get('applied'))}>
            <Checkbox
              checked={onlineOnly.get('applied')}
              dataKey="checkbox-filter"
              handleChange={() => handleToggleFilter(fieldId, onlineOnly)}
              id={`field-${onlineOnly.get('value')}`}
              label={intl.formatMessage({ id: 'STATUS._online_.singleBranch' })}
            />
          </div>
        ) : null}
      </div>
    );
  }

  function renderStatusField() {
    return (
      <SimpleField
        isConjunctive={isConjunctive}
        key="STATUS"
        label={singleBranch ? 'STATUS.field.singleBranch' : 'STATUS.field'}
        fieldId={fieldId}
        hasMore={hasMore}
        filters={filters}
        handleExpandField={handleExpandField}
        handleToggleFilter={handleToggleFilter}
        activeFilters={activeFilters}
        initialIsExpanded={initialIsExpanded}
        handleCloseExpandField={handleCloseExpandField}
        handleToggleExpandedField={handleToggleExpandedField}
        renderFilters={renderFilters}
      />
    );
  }

  if (singleBranch) {
    return renderSingleBranchStatusField();
  }
  return renderStatusField();
}

StatusField.propTypes = {
  filters: ImmutablePropTypes.list,
  handleToggleFilter: PropTypes.func,
  fieldId: PropTypes.string,
  singleBranch: PropTypes.bool,
  activeFilters: PropTypes.object,
  group: PropTypes.string,
  initialIsExpanded: PropTypes.bool,
  isConjunctive: PropTypes.bool,
  hasMore: PropTypes.bool,
  intl: PropTypes.object,
  icon: PropTypes.string,
  iconName: PropTypes.string,
  label: PropTypes.string,
  renderFilters: PropTypes.func,
  handleExpandField: PropTypes.func,
  handleCloseExpandField: PropTypes.func,
  handleToggleExpandedField: PropTypes.func
};

export default injectIntl(StatusField);
